import styled from 'styled-components';

export const MarkdownDisplayWrapper = styled.div`
  a[data-has-custom-label=\"false\"] {
    hyphens: auto;
    word-break: break-all;
  }

  div {
    margin: 0;
    white-space: pre-wrap;
  }
  div + div {
    margin: 10px 0 0;
  }

  h2,
  h3,
  h4,
  blockquote,
  pre,
  hr {
    & + br {
      display: none;
    }
  }

  blockquote {
    font-size: inherit;
    padding: 10px 20px;
    border-left: 5px solid #dcdcdc;
    margin: 5px 0;

    & + br + blockquote {
      margin-top: -5px;
    }

    & > p {
      white-space: pre-wrap;
    }
  }

  h2,
  h3 {
    font-size: 24px;
    line-height: 1.4;
    color: ${({ theme }): string => theme.colors.primary};
    margin: 20px 0 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
  }

  h3,
  h4 {
    font-size: 24px;
    margin: 10px 0 20px;
  }

  h4 {
    font-size: 18px;
  }

  code {
    background: ${({ theme }): string => theme.colors.bodyBg};
    border-radius: 4px;
    display: inline-block;
    margin: -1px 0;
    padding: 1px 3px;
    word-break: break-all;
  }

  pre {
    overflow: hidden;
  }

  pre > code {
    display: block;
    overflow: auto;
  }

  a[href*='?h'] {
    background: ${({ theme }): string => theme.colors.information}20;
    border-radius: 2px;
    padding: 0 3px;
  }

  a[href*='?hs'] {
    background: ${({ theme }): string => theme.colors.information}20;
    pointer-events: none;
    cursor: default;
    color: ${({ theme }): string => theme.colors.gray};
  }

  .search-match {
    background: #fdf1c6;
    border-radius: 2px;
    padding: 0 3px;
  }

  .edited-message-label {
    color: ${({ theme }) => theme.colors.iconGray};
    font-size: 14px;
    font-style: italic;
  }
`;
